import React, { useState, useEffect } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import appUrl from "../../../../constants/appUrl";

const AgainstProductFaq = ({ product }) => {
    const [faqList, setFaqList] = useState([]);

    const getFaqById = async (productId) => {
        try {
            const response = await fetch(`${appUrl.baseUrl}api/FAQ/GetFAQByProductId/${productId}`);
            const data = await response.json();
            setFaqList(data);
        } catch (error) {
            console.error('Error fetching FAQs:', error);
        }
    };

    useEffect(() => {
        if (product && product.productId) {
            getFaqById(product.productId);
        }
    }, [product]);

    return (
        <div className="">
            {faqList.map((faq, index) => (
                <div key={index}>
                    <p style={{ fontWeight: 'bold', margin: '0px' }}>{faq.productID}</p>
                    <p style={{ margin: '0px' }}>{faq.createdDate}</p>
                    <Accordion key={index}>
                        <AccordionTab
                            header={<span className="font-bold white-space-nowrap">{faq.question}</span>}
                        >
                            <p className="m-0">{faq.answer}</p>
                        </AccordionTab>
                    </Accordion>
                </div>
            ))}
        </div>
    );
};

export default AgainstProductFaq;
